import { render, staticRenderFns } from "./BookingsNavigation.vue?vue&type=template&id=baf2d04a"
import script from "./BookingsNavigation.vue?vue&type=script&lang=js"
export * from "./BookingsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports